import React, { useState } from 'react';
import { Container, Paper, Typography, Button, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const authCallbackMessage = (description) => {
  if (description.includes('ACTION_ERROR_TIMEOUT')) {
    return 'Login took too long. Please log in again.';
  }
  if (/invitation/i.test(description) && /expired|not found|already used/i.test(description)) {
    return 'This invitation has expired or has already been used. Ask for a new invitation.';
  }
  return 'Login could not be completed. Please log in again.';
};

const AuthCallback = () => {
  const { error, loginWithRedirect, isLoading } = useAuth0();
  const [search] = useState(() => window.location.search);
  const params = new URLSearchParams(search);
  const description = params.get('error_description') || error?.error_description || error?.message || '';
  const code = params.get('error') || error?.error || '';

  if (isLoading && !code && !description) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress aria-label="Completing login" />
      </Box>
    );
  }

  if (!code && !description) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Could not log in
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {authCallbackMessage(description)}
        </Typography>
        <Box mt={4}>
          <Button variant="contained" color="primary" onClick={() => loginWithRedirect()}>
            Log in
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default AuthCallback;
